import { render, staticRenderFns } from "./icon-arrow.vue?vue&type=template&id=5235275c&"
import script from "./icon-arrow.vue?vue&type=script&lang=js&"
export * from "./icon-arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports